import {NgModel} from "@angular/forms";
import {AbstractModelContainer} from '../inputs/form/form.component';

export enum IntegratedPaymentProvider {
    STRIPE = "stripe",
    TYRO = "tyro",
    OOLIO = "oolio"
}

export const STRIPE_SCRIPT_URL: string = "https://js.stripe.com/v3/";
export const GOOGLE_PAY_SCRIPT_URL: string = "https://pay.google.com/gp/p/js/pay.js";
export const TYRO_SCRIPT_URL: string = "https://pay.connect.tyro.com/v1/tyro.js";
export const ADYEN_SCRIPT_URL: string = "https://checkoutshopper-live-au.cdn.adyen.com/checkoutshopper/sdk/6.8.0/adyen.js";
export const ADYEN_SCRIPT_INTEGRITY: string = "sha384-bxVQwK8MZv5Nf5/TghsCZJ23F+FnlBAKG/6/8XE4SIThMQVLWys04oJ/HhJ+bXKD";
export const ADYEN_STYLESHEET_URL: string = "https://checkoutshopper-live-au.cdn.adyen.com/checkoutshopper/sdk/6.8.0/adyen.css";
export const ADYEN_STYLESHEET_INTEGRITY: string = "sha384-1wJDkAPA2mYXJa7x50LZnHo7oWi5ykc0h7co761i7dtY5Wg4LPCg2i/Q6xDQX02X";

export enum PaymentType {
    GOOGLE_PAY = "google pay",
    APPLE_PAY = "apple pay",
    SAVED_CREDIT_CARD = "saved credit card",
    NEW_CREDIT_CARD = "new credit card",
    POINTS = "points",
    GROUP_PAY = "group pay",
    TAP_TO_PAY = "tap to pay",
    NONE = "none",
}

export enum PaymentAuthorisationType {
    STRIPE_PAYMENT_METHOD = "STRIPE_PAYMENT_METHOD", // stripe card or wallet payment
    STRIPE_PAYMENT_INTENT = "STRIPE_PAYMENT_INTENT", // stripe tap to pay
    TYRO_PAYMENT_INTENT = "TYRO_PAYMENT_INTENT",
    ADYEN_PAYMENT_METHOD = "ADYEN_PAYMENT_METHOD"
}

export enum WalletProvider {
    APPLE_PAY = "apple pay",
    GOOGLE_PAY = "google pay"
}

export enum WalletPaymentErrorType {
    APPLE_PAY_CANCELLED,
    GOOGLE_PAY_CANCELLED,
    INVALID_STATE,
    PROVIDER_ERROR,
    TRANSIENT_ACTIVATION,
    PROVIDER_NOT_READY
}

export class WalletPaymentSubmissionResult {
    constructor(public authorisationType: PaymentAuthorisationType,
                public token?: string,
                public payerName?: string,
                public payerEmail?: string,
                public payerPhone?: string,
                public payerPostcode?: string) {
    }
}

export class WalletPaymentSubmissionFailure {
    // noinspection JSUnusedGlobalSymbols
    constructor(public errorType: WalletPaymentErrorType,
                public providerErrorType?: any,
                public providerErrorMessage?: string,
                public providerErrorCode?: string,
                public providerGatewayCode?: string) {
    }
}

export class CardPaymentSubmissionResult {
    constructor(public authorisationType: PaymentAuthorisationType,
                public token?: string,
                public brand?: string,
                public country?: string,
                public last4?: string) {
    }
}

export class CardPaymentSubmissionFailure {
    constructor(public errorMessage: string,
                public errorCode?: string,
                public gatewayCode?: string,
                public cardValidationFailure: boolean = false,
                public notifiable: boolean = true) {
    }
}

export abstract class PaymentCard extends AbstractModelContainer {
    abstract canSavePaymentDetails(): boolean;

    abstract isValid(): boolean;

    abstract markAsUnsubmitted(): void;

    abstract submit(): Promise<CardPaymentSubmissionResult | CardPaymentSubmissionFailure>;

    getModels(): ReadonlyArray<NgModel> {
        return undefined;
    }
}

export class ThreeDSResult {
    constructor(public success: boolean,
                public paymentIntent: string,
                public error?: any) {
    }
}